var _path, _tspan;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 48.042,
    viewBox: "0 0 40 48.042",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_365",
    "data-name": "Groupe 365",
    transform: "translate(-356.929 -49.694)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_562",
    "data-name": "Trac\\xE9 562",
    d: "M390.929,97.736h-28a6.006,6.006,0,0,1-6-6v-36a6.007,6.007,0,0,1,6-6h.012c9.437.059,14.747,0,17.6-.028,3.555-.039,3.624-.038,4.276.614.4.4,5.133,6.356,6.048,7.512,6.063,7.662,6.063,7.753,6.063,8.623V91.736A6.007,6.007,0,0,1,390.929,97.736Zm-28-44a2,2,0,0,0-2,2v36a2,2,0,0,0,2,2h28a2,2,0,0,0,2-2V67.03c-1.46-2.042-8.436-10.829-10.492-13.338-.461,0-1.112.008-1.852.016C377.719,53.739,372.389,53.8,362.924,53.736Z",
    fill: "#3f82ef"
  })), /*#__PURE__*/React.createElement("g", {
    id: "W",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "W-2",
    "data-name": "W",
    transform: "translate(364.929 88.736)",
    fill: "#3f82ef",
    fontSize: 21,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700,
    letterSpacing: "0.025em",
    style: {
      isolation: "isolate"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "W"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.27fd0575e162de02a2762621b069fce1.svg";
export { ForwardRef as ReactComponent };